export default {
  appName: 'Expédier Qore',
  navigation: {
    reports: 'Rapports',
    programs: 'Programmes',
    dispatching: 'Expéditeur',
    management: 'La Gestion',
    dashboard: 'Tableau de bord',
    dispatchBoard: 'Tableau de répartition',
    dispatchControl: 'Contrôle de l\'expédition',
    customers: 'Les clients',
    clients: 'Clientes',
    services: 'Prestations de service',
    dispatchWorkflows: 'Flux de travail',
    settings: 'Réglages',
    policyVerificationHistory: 'Vérification des politiques',
  }
};
